import React from 'react';

import { LazyHeaderAndFooterPage } from '@confluence/site-settings/entry-points/HeaderAndFooterPage';
import { ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/headerAndFooterConstants';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminHeaderAndFooterRoute = () => <LazyHeaderAndFooterPage />;

AdminHeaderAndFooterRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
